export const JobStatuses = [ "All", "QUEUED", "RUNNING", "COMPLETED", "FAILED", "CANCELLED"]

export interface IJobsResponse {
    "page": number,
    "size": number,
    "total": number,
    "totalsByStatus": {
        [key: string]: number
    },
    "items": IJobMonitor[]
}

export interface IJobMonitor {
    id: string
    vendor: string
    sourceId: string
    externalJobId: string
    title: string
    status: typeof JobStatuses[number] | "All"
    progressPct: number
    submittedAt: string
    startedAt: string
    finishedAt: string
    eta: any
    priority: string
    owner: string
    inputUri: string
    outputUri: string
    vendorStatus: string
    meta: Meta
    createdAt: string
    updatedAt: string
}

export interface Meta {
    node: string
    batch: string
    preset: string
}
